import {stripLeadingZeroes, stripTrailingZeroes} from 'utils/strip.js';

class QueryDecryptor {
    constructor(crypto) {
        this.crypto = crypto;
    }

    async decryptQueryResult(result, privateKey) {
        console.log('query decryptor');
        let encryptedContentKey = stripTrailingZeroes(result.encryptedContentKey);
        let title = await this.crypto.decryptName(result.encryptedName, encryptedContentKey, privateKey)
        let user = result.user;
        let contentKey = await this.crypto.decryptContentKey(encryptedContentKey, privateKey);
        let ret = {
            ... result,
            title:  stripTrailingZeroes(title),
            encryptedTitle:  result.encryptedName,
            user: '0x' + stripLeadingZeroes(user.slice(2)),
            contentKey: contentKey ? contentKey.contentKey : undefined,
            publicKey: stripTrailingZeroes(result.publicKey),
        }

        return ret;
    }
}

export default QueryDecryptor;
